module.exports = __webpack_public_path__ + "static/11-b4b3574187e5d76df899a7eecc79155c.jpg";